import React from 'react';
import moment from 'moment';
import 'moment/locale/pt-br';
import { Container } from './styles';

interface ContractDateProps {
  dateType: string;
  date: string;
}

const ContractDate = (props: ContractDateProps) => {
  const { dateType, date } = props;
  moment.locale('pt-br');
  return (
    <Container className="d-inline-block mb-0 mr-2">
      {dateType && <span className="mr-2 text-secondary">{`${dateType}`}</span>}
      {`${moment.parseZone(date).format('L')}`}
    </Container>
  );
};

export default ContractDate;
